var vuejs = vuejs || {}; //namespace

/**
 * vue.js config
 */
Vue.config.debug = false;
Vue.config.delimiters = ['(%', '%)'];

Vue.filter('number_format', function(value, after) {
    after = after === undefined ? '' : after;
    return number_format(value) + after;
});

/**
 * cookie config
 */
var __visiblePriceKey = 'ENM_isVisiblePrice';
var __invisibleCartConditionKey = 'ENM_isInvisibleCartCondition';

/**
 * ajaxSetup
 */
$.ajaxSetup({
    headers: {
        'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
    },
});
